module.exports = __webpack_public_path__ + "static/media/subscription4.57d3b920.png";